module.exports = __webpack_public_path__ + "img/stakebody_parked.49bacc2a.svg";